import type { SupabaseClient } from "@supabase/supabase-js";
import { createEmptyContentSnapshotV2 } from "../../runtime/content/ContentSnapshotV2";
import type { RuntimeAsset } from "../../runtime/content/RuntimeContent";
import { getSupabaseClient } from "../../shared/supabase";
import { DraftRuntimeContent } from "../runtime-preview/DraftRuntimeContent";

export type CoreKnightOption = { id: string; key: string; name: string; role: string; premium: boolean };
function client() { const result = getSupabaseClient(); if (!result.ok) throw new Error(result.message); return result.client as unknown as SupabaseClient; }
export async function listCoreKnights(): Promise<CoreKnightOption[]> { const { data, error } = await client().from("core_knight_definition").select("id,key,name,role,premium").eq("enabled", true).order("name"); if (error) throw error; return (data ?? []) as CoreKnightOption[]; }

export class CoreKnightDraftAdapter extends DraftRuntimeContent {
  static fromSnapshot(value: unknown) { const adapter = new CoreKnightDraftAdapter(); adapter.setSnapshot(value); return adapter; }
  async loadKnight(id: string) {
    const db = client();
    const { data, error } = await db.from("core_knight_definition").select("*").eq("id", id).single();
    if (error || !data) throw error ?? new Error("Core Knight not found.");
    const row = data as any;
    const ids = [row.full_body_asset_id, row.portrait_asset_id].filter(Boolean) as string[];
    const assets: Record<string, RuntimeAsset> = {};
    if (ids.length) {
      const assetResult = await db.from("asset").select("id,key,name,current_version_id").in("id", ids);
      if (assetResult.error) throw assetResult.error;
      for (const asset of (assetResult.data ?? []) as any[]) assets[asset.id] = { id: asset.id, key: asset.key, name: asset.name, versionId: asset.current_version_id };
    }
    const snapshot = createEmptyContentSnapshotV2(`draft:${row.updated_at}`);
    snapshot.assets = assets;
    snapshot.core.knights[row.key] = { id: row.id, key: row.key, name: row.name, role: row.role, premium: row.premium,
      fullBodyAssetId: row.full_body_asset_id, portraitAssetId: row.portrait_asset_id, enabled: row.enabled };
    this.setSnapshot(snapshot);
    return this;
  }
}
